import React, { useContext, useEffect } from 'react';
import styled from 'styled-components';
import MainContext from 'MainContext';
import { ThemeContext } from 'context/themeContext';
import Currency from 'components/currency';
import { useTranslation } from 'react-i18next';

const Wrapper = styled.div`
  position: absolute;
  right: ${(props) => (props.rtlDirection ? 'unset' : '1.04vw')};
  left: ${(props) => (props.rtlDirection ? '1.04vw' : 'unset')};
  bottom: 0;
  background-color: ${(props) => props.theme.cardBackground};
  border-radius: 1.56vw;
  width: 24.466vw;
  height: 8.276vw;
  padding-top: 0.56vw;
  box-sizing: border-box;
`;

const Total = styled.div`
  position: absolute;
  bottom: 0;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  right: ${(props) => (props.rtlDirection ? '1.56vw' : 'unset')};
  font-size: 1.04vw;
  font-weight: bold;
  color: ${(props) => props.theme.textPrimary};
  border-top: 1px solid ${(props) => props.theme.borderBackground};
  width: 21.343vw;
  height: 3.123vw;
  box-sizing: border-box;
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Text = styled.div`
  position: relative;
  bottom: 0;
  left: ${(props) => (props.rtlDirection ? 'unset' : '1.56vw')};
  right: ${(props) => (props.rtlDirection ? '1.56vw' : 'unset')};
  font-size: 0.832vw;
  color: ${(props) => props.theme.textSecondary};
  width: 21.343vw;
  height: 1.249vw;
  box-sizing: border-box;
  padding-left: 2px;
  padding-right: 2px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const App = (props) => {
  const { theme, rtlDirection } = useContext(ThemeContext);
  const { tax, selectedDelivery, discount, discountAmount, setDiscountAmount, setFinalPrice } =
    useContext(MainContext).checkout;
  const { basketOrders } = useContext(MainContext).cart;
  const { t } = useTranslation();
  const { totalPrice, orderRFQ } = props;

  useEffect(() => {
    let discountAmountHelper = 0;
    if (discount.name) {
      basketOrders.map((order) => {
        if (discount.type === 'percent') {
          if (discount.colors.includes(order.color)) {
            discountAmountHelper += order.price * (discount.code_price / 100);
          }
        } else {
          if (discount.colors.includes(order.color)) {
            discountAmountHelper = order.price;
          }
        }
      });
      if (discount.type === 'percent') {
        discountAmountHelper = Math.min(discountAmountHelper, discount.maximum);
      } else {
        discountAmountHelper = Math.min(discountAmountHelper, discount.code_price);
      }
    }
    setDiscountAmount(discountAmountHelper);
  }, [discount]);

  const finalPrice = (1 + tax / 100) * totalPrice + selectedDelivery.price - discountAmount;
  useEffect(() => {
    setFinalPrice(finalPrice);
  }, [finalPrice]);

  return (
    <Wrapper rtlDirection={rtlDirection} theme={theme}>
      <Text rtlDirection={rtlDirection} theme={theme}>
        <div>{t('checkout.payment info.Tax')}{'('+tax+'%)'}</div>
        <Currency value={(tax * totalPrice) / 100} />
      </Text>
      <Text rtlDirection={rtlDirection} theme={theme}>
        <div>{t('checkout.payment info.Shipping')}</div>
        <Currency value={selectedDelivery.price} />
      </Text>
      <Text rtlDirection={rtlDirection} theme={theme}>
        <div>{t('checkout.payment info.Discount')}</div>
        <Currency value={-Math.floor(discountAmount * 100) * 0.01} />
      </Text>
      <Total rtlDirection={rtlDirection} theme={theme}>
        <div>{t('checkout.payment info.Total Amount')} {orderRFQ && '+ RFQ'} </div>
        {/* <Currency value={Math.floor(finalPrice * 100) * 0.01} />  this line is chenged to below one by qazal for preventing of huge number */}
        <Currency
          value={
            Number.isInteger(Math.floor(finalPrice * 100) * 0.01)
              ? Math.floor(finalPrice * 100) * 0.01
              : parseFloat(Math.floor(finalPrice * 100) * 0.01).toFixed(2)
          }
        />
      </Total>
    </Wrapper>
  );
};

export default App;
